import React, { Fragment } from 'react';
const Checkbox = ({ data, name, selectedFilters, onChange }) => {
    return (React.createElement(Fragment, null, data.map((option) => {
        const id = option.id ?? '';
        return (React.createElement("div", { key: id, className: "form-input-container form-input-container--clickable" },
            React.createElement("input", { id: id, className: "form-clickable form-clickable--checkbox", checked: selectedFilters.includes(id), name: name, type: "checkbox", value: id, onChange: onChange }),
            React.createElement("label", { className: "form-label", htmlFor: id }, option.name)));
    })));
};
export default Checkbox;
